export const REQUEST_STATUSES = {
  FULFILLED: "fulfilled",
  REJECTED: "rejected",
};

export const PINCODE_MAP_MESSAGES = {
  SERVICEABLE_PINS_FAILED_SHOWING_NON_SERVICEABLE:
    "Serviceable pincodes failed to load. Showing non-serviceable data only.",
  NON_SERVICEABLE_PINS_FAILED: "Non-serviceable pincodes failed to load.",
  PINCODE_SERVICEABILITY_LOAD_FAILED: "Failed to load pincode serviceability data",
  HUB_LIST_LOAD_FAILED: "Failed to load hub listing",
};
